import { useEffect } from 'react';
import {
  formAdvanceSearchPageQuery,
  getProcessEnvs,
  handleErrorPageRedirects,
  updateSessionDocErrorMessages,
} from '@marriott/mi-shop-components';
import Cookies from 'js-cookie';

const { SESSION_APP_GET_CALL_URL, SESSION_APP_POST_CALL_URL } = getProcessEnvs();

export default function Custom404() {
  useEffect(() => {
    const pageRedirectUrl = handleErrorPageRedirects();

    async function handleSessionUpdateAndRedirect() {
      const sessionID = Cookies.get('sessionID');
      let searchPageQueryParams = '';

      if (sessionID) {
        // update message in session document - Error message `Our Servers are being stubborn !`
        const sessionData = await updateSessionDocErrorMessages(
          sessionID,
          SESSION_APP_GET_CALL_URL,
          SESSION_APP_POST_CALL_URL,
          ['search-error-messages|server.stubborn.try.again']
        );
        searchPageQueryParams = formAdvanceSearchPageQuery({ sessionData, addErrorParams: true });
      }
      //redirect to configured page with new query params appended
      if (location.href.indexOf(pageRedirectUrl) === -1) {
        location.href = `${pageRedirectUrl}?${searchPageQueryParams}` || '/';
      }
    }

    handleSessionUpdateAndRedirect();
  }, []);

  return null;
}
